// extracted by mini-css-extract-plugin
export default {"chart":"Radar_chart__jNxlm"};